/**
 * LabelIcon/index.js
 * desc: label icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LabelIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="label-on icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.label.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg"><path d="M15.4 3.78c-.379-.474-1.01-.78-1.716-.78l-11.579.01C.947 3.01 0 3.835 0 4.856v9.286c0 1.021.947 1.848 2.105 1.848l11.58.009c.704 0 1.336-.306 1.715-.78L20 9.5l-4.6-5.72z"/></svg>
    </IconButton>
);


export default LabelIcon;
